import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import '@angular/compiler';

import { AppModule } from './app/app.module';
import { environmentConfigs } from './environments/environment-config';

// تحديد البيئة بناءً على identifier
function getEnvironmentIdentifier(): string {
  // 1. محاولة الحصول من متغيرات البيئة
  const envVar = (window as any).ENVIRONMENT_IDENTIFIER;
  if (envVar) {
    return envVar;
  }

  // 2. محاولة الحصول من localStorage
  const localStorageEnv = localStorage.getItem('environment_identifier');
  if (localStorageEnv) {
    return localStorageEnv;
  }

  // 3. محاولة الحصول من URL parameters
  const urlParams = new URLSearchParams(window.location.search);
  const urlEnv = urlParams.get('env');
  if (urlEnv) {
    return urlEnv;
  }

  // 4. محاولة الحصول من hostname
  const hostname = window.location.hostname;

  const environments: Record<string, string> = {
    'dev.tryglamera.com': 'dev',
    'dev.localhost': 'dev',
    'stage.tryglamera.com': 'stage',
    'stage.localhost': 'stage',
    'pro.tryglamera.com': 'pro',
    'pro.localhost': 'pro',
    'sys.tryglamera.com': 'sys',
    'sys.localhost': 'sys',
    'app.tryglamera.com': 'app',
    'app.localhost': 'app',
    'prodump.tryglamera.com': 'prodump',
    'prodump.localhost': 'prodump',
    'live.tryglamera.com': 'live',
    'live.localhost': 'live',
  };
  // دور على أول key بيطابق الـ hostname
  for (const key in environments) {
    if (hostname.includes(key)) {
      return environments[key];
    }
  }

  return 'dev'; // default
}

// الحصول على البيئة المحددة
const identifier = getEnvironmentIdentifier();
const environment = environmentConfigs[identifier] || environmentConfigs['dev'];

// تعيين البيئة في window object للوصول إليها من أي مكان
(window as any).environment = environment;

if (environment.production) {
  enableProdMode();
}

console.log(`Starting application with environment: ${identifier}`);

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
